// import { AsciiEffect } from '../modules/0xAsciiEffect.js';
// import { AsciiShader } from '../modules/0xAsciiShader.js';
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
// import { AsciiEffect } from '../modules/0xAsciiEffect.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

const easeOutQuad = t => t * ( 2 - t );
const easeOutExpo = t => t === 1 ? 1 : 1 - Math.pow(2, -10 * t);

const LOGODIST = 1000;
const POSRANGE = window.innerWidth > 767 ? 200 : 100;
const RESETPOS = 200; // for +y and -y

// const ASCIICHARACTERS = ' .\'`^*",/;~+_-}{1)(|0#';
// const ASCIICHARACTERS = ' .:-+*=%☺@#'

export default class aboutAscii {
  constructor(){
    // this.ASCIICHARACTERS = ' .\'`^*",/;~+_-}{1)(|0#';
    this.ASCIICHARACTERS = $('#asciiLetters').val();

    // this.ASCIICHARACTERS = $('#asciiLetters').val();

    this.start = null;

    this.doIntro = true;
    this.rotRange = new THREE.Vector3(.5, .3, 0);
    this.speed = 0.0001;

    // this.newEffect = AsciiEffect;

    this.image = undefined;
    this.camera = undefined;
    this.controls = undefined;
    this.scene = undefined;
    this.renderer = undefined;
    this.composer = undefined;
    this.effect = undefined;

    this.pointLight1 = undefined;
    this.pointLight2 = undefined;

    this.sphere = undefined;
    this.plane = undefined;
    this.image = undefined;
    this.sprite = undefined;
    
    this.asciiPass = undefined;

    // var shader = new AsciiShader();
    var uniforms = {
      time: {
        type: "f",
        value: 1.0
      },
      resolution: {
        type: "v2",
        value: new THREE.Vector2()
      },
      charsize : {
        type: "f",
        value: 4.0,
      },
      brightness : {
        type: "f",
        value: 0.12,
      }
    };
    uniforms.resolution.value.x = window.innerWidth;
    uniforms.resolution.value.y = window.innerHeight;
    
    this.shaderMaterial = new THREE.ShaderMaterial({
      uniforms: uniforms,
      vertexShader: document.getElementById('asc-general').textContent,
      fragmentShader: document.getElementById('asc-frag1').textContent
    });
    this.clock = new THREE.Clock();


    this.ORIGSPRITESCALE = MOBSIZE ? 20 : 30;

    this.init = this.init.bind(this);
    this.binds = this.binds.bind(this);
    this.animate = this.animate.bind(this);
    this.render = this.render.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.scrollLogos = this.scrollLogos.bind(this);

    this.sources = $('.client-logo').toArray();
    // this.sources.join($('.client-logo').toArray());
    this.logos = [];

    this.init();
    this.binds();
    this.animate();

  }

  binds() {
    var parent = this;
    $('#asciiLetters').on('input', function(){
      if($(this).val().indexOf(' ')!==0){
        $(this).val(' '+$(this).val());
      }
      let v = $(this).val();
      parent.ASCIICHARACTERS = v;
      parent.effect.aCharList = v;
    });

    $('#range').on('mousemove input', function(){
      let prc = $(this).val()/100;
      window.expertAscii.range = prc;
    });

    $('#speed').on('mousemove input', function(){
      let prc = $(this).val()/100000;
      window.expertAscii.speed = prc;
    });


    $(window).unbind('scroll').scroll(function(){
      let top = $(window).scrollTop();
      if(!MOBSIZE) {
        window.scrolling = true;
        if(top > 1){
          console.log('down');
          $(window).scrollTop(1);
          if(window.aboutAscii) window.aboutAscii.scrollLogos(1);
        } else if(top < 1) {
          console.log('up');
          $(window).scrollTop(1);
          if(window.aboutAscii) window.aboutAscii.scrollLogos(-1);
        }

        if(window.backgroundAnim) window.backgroundAnim.addSplashes();
      }

    });
  }

  scrollLogos(val){
    var parent = this;
    console.log(val);
    if(this.logos){
      // clearTimeout(window.aboutStopScroll);
      // this.stopScroll = true;
      for(var i=0;i<this.logos.length;i++){
        // let value = val > 0 ? 2 : -1;
        this.logos[i].speed += val * 0.2;
        this.logos[i].speed = Math.min(Math.max(this.logos[i].speed, -3), 3);
        if(this.logos[i].speed==0){
          this.logos[i].speed = val*0.05;
        }
      }
      // window.aboutStopScroll = setTimeout(function(){
      //   parent.stopScroll = false;
      // }, 20);
    }
  }

  init() {
    let camera = this.camera;
    let controls = this.controls;
    let scene = this.scene;
    let renderer = this.renderer;
    let effect = this.effect;
    let composer = this.composer;

    let sphere = this.sphere;
    let plane = this.plane;
    let image = this.image;
    let sprite = this.sprite;

    let pointLight1 = this.pointLight1;
    let pointLight2 = this.pointLight2;

    this.camera = new THREE.PerspectiveCamera( 10, window.innerWidth / window.innerHeight, 1, 5000 );
    this.camera.position.y = 0;
    this.camera.position.z = 500;

    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color( 0, 0, 0 );

    this.pointLight1 = new THREE.PointLight( 0xffffff, 0.0);
    this.pointLight1.position.set( 400, 400, 400 );
    this.scene.add( this.pointLight1 );

    this.pointLight2 = new THREE.PointLight( 0xffffff, 0.0);
    this.pointLight2.position.set( -500, -500, -500 );
    this.scene.add( this.pointLight2 );

    this.renderer = new THREE.WebGLRenderer({
      powerPreference: "low-power",
    });
    this.renderer.setSize( window.innerWidth, window.innerHeight );

    this.composer = new EffectComposer( this.renderer );
    this.composer.addPass( new RenderPass( this.scene, this.camera ) );
    this.composer.setSize( window.innerWidth, window.innerHeight );

    this.asciiPass = new ShaderPass(this.shaderMaterial, "media");
    this.shaderMaterial.uniforms.media = this.composer.renderTarget1;
    this.composer.addPass( this.asciiPass );

    // this.renderer.shadowMap.enabled = true;

    // this.effect = new AsciiEffect( this.renderer, this.ASCIICHARACTERS, { 
    //   invert: true,
    //   resolution: MOBSIZE ? 0.3 : .3,
    // } );
    // this.effect.setSize( window.innerWidth, window.innerHeight );
    // this.effect.domElement.style.color = 'white';
    // var addTo = $('.about-ascii').get(0);
    // this.renderer.domElement.className = 'ascii-expert';
    // this.effect.domElement.className = 'ascii-expert';
    // addTo.appendChild( this.effect.domElement );
    var addTo = $('.about-ascii').get(0);
    addTo.appendChild( this.renderer.domElement );

    // this.controls = new TrackballControls( this.camera, this.renderer.domElement );
    // this.controls = new TrackballControls( this.camera, this.effect.domElement );

    const material = new THREE.MeshPhongMaterial( {
      color: 0xAAAAAA, specular: 0x111111, shininess: 200
    });


    const intersectorGeometry = new THREE.PlaneGeometry( 1000, 1000 );
    const intersectorMaterial = new THREE.MeshBasicMaterial( {
      color: 0xffff00,
      visible: false,
    });

    var intersector = new THREE.Mesh( intersectorGeometry, intersectorMaterial );


    for(var i=0;i<this.sources.length;i++){

      const loader = new THREE.TextureLoader();
      const source = this.sources[i];
      const LOADURL = this.sources[i].src;
      // const LOADURL = $('.expert-photo').attr('data-square');

      var parent = this;

      loader.load( LOADURL, function ( texture ) {

        parent.start = Date.now();

        let szMultip = .15;
        let sz = window.innerHeight<window.innerWidth ? window.innerHeight * szMultip : window.innerWidth * szMultip;

        if(MOBSIZE) {
          sz = window.innerWidth * .2;
        }

        let ratio = source.height/source.width;

        const geometry = new THREE.PlaneGeometry( sz, sz*ratio );
        const material = new THREE.MeshBasicMaterial( {
          color: 0xdddddd,
          map: texture,
          side: THREE.DoubleSide
        } );


        var newLogo = new THREE.Mesh( geometry, material );

        newLogo.name = 'image';

        newLogo.position.x = Math.random()*POSRANGE - POSRANGE*.5;
        newLogo.position.y = Math.random()*POSRANGE - POSRANGE*.5;
        newLogo.position.z = -LOGODIST;

        newLogo.speed = Math.random() + .5;

        console.log('image done',image);

        newLogo.rotRange = parent.rotRange;

        parent.logos.push(newLogo);

        parent.scene.add( newLogo );

        // parent.effect.domElement.classList += ' show';

    });

  }

    const spriteMap = new THREE.TextureLoader().load( siteurl+'/assets/i/fadeSpriteLess.png' );
    const spriteMaterial = new THREE.SpriteMaterial( { map: spriteMap } );

    this.sprite = new THREE.Sprite( spriteMaterial );
    this.sprite.scale.set(this.ORIGSPRITESCALE, this.ORIGSPRITESCALE, this.ORIGSPRITESCALE)
    this.sprite.position.x = 9999;
    this.sprite.position.y = 9999;
    this.sprite.position.z = 30;
    this.scene.add( this.sprite );

    window.addEventListener( 'resize', this.onWindowResize );

    var raycaster = new THREE.Raycaster();

    document.addEventListener( 'mousemove', function(event){
        // console.log(event);
        if(intersector) {
          let x = (event.x / parent.renderer.domElement.clientWidth ) * 2 - 1;
          let y = - ( event.y / parent.renderer.domElement.clientHeight ) * 2 + 1;

          let threePos = new THREE.Vector3(x,y,0);

          raycaster.setFromCamera( threePos, parent.camera );
          var intersects = raycaster.intersectObject( intersector );
          if ( intersects.length > 0 ) {
            var point = intersects[ 0 ].point;
            parent.sprite.position.set(point.x, point.y, 20);
          }
        }
      }, false );

  }


  onWindowResize() {

    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize( window.innerWidth, window.innerHeight );
    this.composer.setSize( window.innerWidth, window.innerHeight );

    this.shaderMaterial.uniforms.resolution.value.x = window.innerWidth;
    this.shaderMaterial.uniforms.resolution.value.y = window.innerHeight;
    
  }

  animate() {
    window.introRaf = requestAnimationFrame( this.animate );
    if(this.shaderMaterial){
      this.shaderMaterial.uniforms.time.value = this.clock.getElapsedTime();
    }
    // console.log(this.asciiPass);
    // this.composer.render(this.scene, this.camera);
    // this.composer.render(this.scene, this.camera);
    this.render();
  }

  render() {
    const timer = Date.now() - this.start;
    let positionDuration = 1500;

    if(this.logos) {
      for(var i=0;i<this.logos.length;i++){
        const progressPosQuad = easeOutQuad( Math.min(positionDuration, timer) / positionDuration );
        const progressPos = easeOutExpo( Math.min(positionDuration, timer) / positionDuration );
        if(progressPos<1){
          this.logos[i].position.z = 500 - ((LOGODIST + 500)*progressPos);
        }

        if(!this.stopScroll){
          this.logos[i].position.y -= this.logos[i].speed;
        }

        if(this.logos[i].position.y < -RESETPOS) {
          this.logos[i].position.z = -LOGODIST + (Math.random()*500);
          this.logos[i].position.y = RESETPOS;
          this.logos[i].position.x = Math.random()*POSRANGE - POSRANGE*.5;
          // this.logos[i].speed = Math.random() + .5;
          this.logos[i].rotRange = new THREE.Vector3(Math.random()*1 - .5, Math.random()*1 - .5, 0);
        }
        if(this.logos[i].position.y > RESETPOS) {
          this.logos[i].position.z = -LOGODIST + (Math.random()*500);
          this.logos[i].position.y = -RESETPOS;
          this.logos[i].position.x = Math.random()*POSRANGE - POSRANGE*.5;  
          this.logos[i].rotRange = new THREE.Vector3(Math.random()*1 - .5, Math.random()*1 - .5, 0);
        }

        this.logos[i].position.z += 0.1;

        // this.logos[i].rotation.x = -Math.PI * this.rotRange + ((Math.PI * this.rotRange)*progressPos);

        this.logos[i].rotation.x = Math.sin(timer*this.speed) * (this.logos[i].rotRange.x);
        this.logos[i].rotation.y = Math.sin(timer*this.speed*3) * (this.logos[i].rotRange.y);

        $('.about-ascii').css({
            // 'transform': 'scale('+(2 - progressPosQuad)+')',
            'opacity': progressPos
        });
      }
    }

    if(this.sprite){
      var spriteScale = this.ORIGSPRITESCALE + (Math.sin(timer*0.001) * 5);
      this.sprite.scale.set(spriteScale, spriteScale, spriteScale)
    }

    // this.controls.update();
    // this.renderer.render( this.scene, this.camera );
    this.composer.render(this.scene, this.camera);
    // this.effect.render( this.scene, this.camera );
  }
}
